export default __webpack_public_path__ + "static/media/mujer.6f0d04ec.png";